import React, { useRef, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import "../Style/_reviewForm.scss";

const ReviewForm = ({ addReview }) => {
  const [name, setName] = useState("");
  const [comment, setComment] = useState("");
  const [website, setWebsite] = useState(""); // pot de miel anti-robots
  const [recaptchaValue, setRecaptchaValue] = useState(null);
  const recaptchaRef = useRef(null);

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!recaptchaValue) return;
    const formattedComment = `"${comment}"`;
    addReview({ name, comment: formattedComment, website, recaptcha: recaptchaValue });
    // Un jeton reCAPTCHA n'est valable qu'une fois
    recaptchaRef.current?.reset();
    setRecaptchaValue(null);
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="name_field">
        <label htmlFor="name">Nom :</label>
        <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} maxLength={80} required />
      </div>
      <div className="reviex_field">
        <label htmlFor="review">Avis :</label>
        <textarea id="review" value={comment} onChange={(e) => setComment(e.target.value)} maxLength={1998} required />
      </div>
      <input
        type="text"
        name="website"
        value={website}
        onChange={(e) => setWebsite(e.target.value)}
        style={{ display: "none" }}
        tabIndex="-1"
        autoComplete="off"
        aria-hidden="true"
      />
      <div>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey="6Ld4KfYpAAAAAG2ruwjfATWLtnTYnqy1zYoQw_q0" // clef de site reCAPTCHA
          onChange={(value) => setRecaptchaValue(value)}
          onExpired={() => setRecaptchaValue(null)}
        />
      </div>
      <p className="review_notice">
        Votre nom et votre avis seront publiés sur ce site après validation. Ce formulaire est protégé par reCAPTCHA de Google. Détails dans « Mentions légales et confidentialité » en bas de page.
      </p>
      <button type="submit" disabled={!recaptchaValue}>
        Ajouter un avis
      </button>
    </form>
  );
};

export default ReviewForm;
